'use strict'

import moment from 'moment'
import { useQuestStore } from '@/stores'
import { EventBus } from '@/lib'

export const QuestState = {
    CANCELLED: 'CANCELLED',  // quest can still be seen by players that started the quest; quest cannot be seen by new players
    CREATED: 'CREATED',      // quest was created
    PUBLISHED: 'PUBLISHED',  // quest data cannot be changed anymore; quest can now be seen by all players
}

export const QuestHelpers = {
    isCancelled(quest) {
        return (quest.state === QuestState.CANCELLED)
    },
    isCreated(quest) {
        return (quest.state === QuestState.CREATED)
    },
    isPublished(quest) {
        return (quest.state === QuestState.PUBLISHED)
    },
    isPublishedOrCancelled(quest) {
        return (quest.state === QuestState.PUBLISHED ||
                quest.state === QuestState.CANCELLED)
    },
    isEditable(quest) {
        return !this.isPublishedOrCancelled(quest) || !quest.title_id
    },
    showSubNavigation(quest) {
        return quest.quest_id && quest.title_id
    },
    getReadableQuestState(quest) {
        if (!quest || !quest.state) {
            return ''
        }
        let state = quest.state.toLowerCase()
        return state.charAt(0).toUpperCase() + state.slice(1)
    },
    getReadableQuestDate(dateTime) {
        const dateFormat = "MM-DD-YYYY"
        let momentDate = new Date(dateTime)
        return moment(momentDate).format(dateFormat)
    },
    async getSourceQuests(force = false) {
        EventBus.$emit('showQuestLoader')
        const { getSourceQuests } = useQuestStore()
        const quests = await getSourceQuests(this, force)
        EventBus.$emit('hideQuestLoader')
        return quests
    },
    async getTargetQuests(force = false) {
        EventBus.$emit('showQuestLoader')
        const { getTargetQuests } = useQuestStore()
        const quests = await getTargetQuests(this, force)
        EventBus.$emit('hideQuestLoader')
        return quests
    },
    stripExtraneousFields(quest) {
        const invalidQuestProps = [
            'sort_order',
            'studio_prefix',
            'target_studio_prefix',
            'target_title',
            'state',
        ]
        for (let i = 0; i < invalidQuestProps.length; i++) {
            let prop = invalidQuestProps[i]
            delete quest[[prop]]
        }
        return quest
    },
    getTitleForQuest(quest) {
        let questTitleText = 'No title'
        const titles = Object.values(quest.title);
        if (titles.length) {
            return titles[0]
        }
        return questTitleText
    },
    createEmptyQuest() {
        return {
            "active_from_dt": null,
            "active_to_dt": null,
            "available_languages": [],
            "completion_conditions": {},
            "description": {},
            "images": {},
            "player_requirements": {},
            "reward": "",
            "sort_order": "1",
            "target_title_id": "",
            "target_title": {},
            "state": "",
            "title_id": "",
            "title": {},
            "quest_id": ""
        }
    },
}
